module.exports = __webpack_public_path__ + "static/img/shadow1.ec98fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoDetail/shadow1.png
// module id = D6/N
// module chunks = 17